import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-orcamento-info',
  templateUrl: './modal-orcamento-info.component.html',
  styleUrls: ['./modal-orcamento-info.component.css']
})
export class ModalOrcamentoInfoComponent implements OnInit {
  @Input() jsonDados: dadosChamadoModal = new dadosChamadoModal();
  constructor(
    public bsModalRef: BsModalRef,
  ) { }

  ngOnInit(): void {
  }

  copiarProtocolo() {
    const elementoTemporario = document.createElement('textarea');
    elementoTemporario.value = this.jsonDados.protocolo;
    document.body.appendChild(elementoTemporario);
    elementoTemporario.select();
    document.execCommand('copy');
    document.body.removeChild(elementoTemporario);
    $('.click-to-copy-modal').removeClass('fa-copy');
    $('.click-to-copy-modal').addClass('fa-check');
    $('.alertSpanModal').text('Protocolo copiado!');
    setTimeout(() => {
      $('.click-to-copy-modal').addClass('fa-copy');
      $('.alertSpanModal').text(null);
    }, 2000);
  }

}

export class dadosChamadoModal {
  protocolo: string;
  placa: string;
  data_abertura: string;
  nome: string;
  atribuicao: string;
  responsavel: string;
  cobertura: string;
  situacao: string;
}